import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled, { CSSProp } from 'styled-components';
import { HeaderSpacing } from '.';

export const SPACING_MAP: Record<HeaderSpacing, string> = Object.freeze({
  DEFAULT: '5.6rem 0 7.4rem',
  WITH_ACTION_BELOW: '5.6rem 0 5.2rem',
});

export const HeaderStyled = styled.header<{ $spacing: HeaderSpacing }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props): CSSProp => SPACING_MAP[props.$spacing] ?? SPACING_MAP.DEFAULT};
  position: relative;
`;

export const TitleStyled = styled.h1`
  color: ${colors.neutral[900]};
  font-size: 3.4rem;
  line-height: 4rem;
  font-weight: 700;
  margin: 0;
`;

export const TextWrapperStyled = styled.div`
  text-align: center;
`;

export const SubtitleStyled = styled.p<{ $maxWidth?: string }>`
  padding-top: 1.2rem;
  margin: 0 auto;
  font-size: 1.8rem;
  line-height: 2.8rem;
  letter-spacing: 0.02rem;

  /* 
  max-width is set to 100% for short subtitles, ensuring they span the full width.
  For longer text, you can specify a custom max-width value to control the layout.
  Alternatively, use <br/> within the subtitle to break the text and adjust the view as needed.
*/
  max-width: ${(props): CSSProp => props.$maxWidth || '100%'};
`;

export const BackButtonStyled = styled(Button)`
  padding-left: 0;
  position: absolute;
  left: 0;

  @media (width <= 600px) {
    top: 1rem;
    left: 1rem;
  }
`;
